<template>
  <div class="addRom">
    <el-form :model="romForm" :rules="romRules" ref="romForm" class="demo-romForm" label-position="left">

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="rom图标" prop="romIcon">
            <upload-img :fixedNumber="[690, 256]" fixedName="690:256" accept="image/*" tip="" uploadName="上传图标"
              @uploadInfo="uploadInfo" :fixedFlag="false" fileDir="rom_icon" :resultImg="romForm.romIcon" />
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item style="margin-top: 52px">
            <el-button type="primary" @click="submitForm('romForm')" class="enter-btn save-btn"
              :loading="submitLoading">保存</el-button>
            <el-button @click="resetForm('romForm')" class="cancel-btn calloff-btn">取消</el-button>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="rom名字(中文)" prop="romName">
            <el-input v-model="romForm.romName" placeholder="请输入rom名字(中文)"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="rom名字(英文)" prop="romNameEn">
            <el-input v-model="romForm.romNameEn" placeholder="请输入rom名字(英文)"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="描述(中文)" prop="description">
            <el-input v-model="romForm.description" placeholder="请输入描述(中文)"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="描述(英文)" prop="descriptionEn">
            <el-input v-model="romForm.descriptionEn" placeholder="请输入描述(英文)"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="rom类型" prop="romType">
            <el-select v-model="romForm.romType" placeholder="请选择rom类型">
              <el-option v-for="item in romTypeList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="游戏类型" prop="romGameType">
            <el-select v-model="romForm.romGameType" placeholder="请选择游戏类型">
              <el-option v-for="item in romGameTypeList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="下载地址" prop="downloadLink">
            <el-input v-model="romForm.downloadLink" placeholder="请输入下载地址"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="主文件" prop="mainFile">
            <el-input v-model="romForm.mainFile" placeholder="请输入主文件"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="2号下载地址(宁波)" prop="downloadLink">
            <el-input v-model="romForm.twoDownloadLink" placeholder="请输入2号下载地址(宁波)"></el-input>
          </el-form-item>
        </el-col>

      </el-row>

      <el-form-item label="">
        <el-table :data="romForm.romPlatformList" border size="mini">
          <el-table-column label="平台名字">
            <template slot-scope="scope">
              <el-select v-model="scope.row.romSupportedPlatform" placeholder="请选择支持平台">
                <el-option v-for="item in romSupportedPlatformList" :key="Number(item.value)" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </template>
          </el-table-column>

          <el-table-column label="状态">
            <template slot-scope="scope">
              <el-select v-model="scope.row.status" placeholder="请选择状态">
                <el-option v-for="item in statusList" :key="Number(item.value)" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </template>
          </el-table-column>

          <el-table-column label="核心名字">
            <template slot-scope="scope">
              <el-input v-model="scope.row.coreName" placeholder="请输入核心名字"></el-input>
            </template>
          </el-table-column>
          <el-table-column>
            <template slot="header">
              <div style="display: flex; width: 100%; justify-content: space-between; align-items: center;">
                <span>备注</span>
                <el-button size="mini" type="primary" round icon="el-icon-thumb"
                  @click="addPlatformRow">新增平台</el-button>
              </div>
            </template>
            <!-- <template slot-scope="scope">
              <el-input v-model="scope.row.notes" placeholder="选填"></el-input>
              <el-button size="mini" icon="el-icon-delete" @click="scope.row.notes = ''"></el-button>
            </template> -->

            <template slot-scope="scope">
              <div style="display:flex; gap: 6px; align-items: center; width:100%;">
                <el-input v-model="scope.row.notes" placeholder="选填" style="flex:1;"></el-input>
                <el-button size="mini" icon="el-icon-delete" style="z-index: 10;"
                  @click.stop="scope.row.notes = ''"></el-button>
              </div>
            </template>

          </el-table-column>
        </el-table>
      </el-form-item>

      <!--   冗余字段 -->
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="文件大小(无法操作)" prop="fileSize">
            <el-input v-model="romForm.fileSize"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="云文件路径(无法操作)" prop="cloudFilePath">
            <el-input v-model="romForm.cloudFilePath" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import UploadImg from "../../../components/UploadImg";
import { setRom, getRomDetail } from "@/api/simulator";
export default {
  components: { UploadImg },
  data() {
    return {
      romForm: {
        romIcon: "",
        romName: "",
        romNameEn: "",
        description: "",
        descriptionEn: "",
        romType: "",
        romGameType: "",
        downloadLink: "",
        twoDownloadLink: "",
        mainFile: "",
        romPlatformList: [],
      },
      romTypeList: [],
      romGameTypeList: [],
      romSupportedPlatformList: [],
      statusList: [],
      romRules: {
        romIcon: [
          { required: true, message: "请上传rom图标", trigger: "change" },
        ],

        romNameEn: [
          { required: true, message: "请输入名字(英文)", trigger: "blur" },
        ],

        description: [
          { required: true, message: "请输入描述(中文)", trigger: "blur" },
        ],

        descriptionEn: [
          { required: true, message: "请输入描述(英文)", trigger: "blur" },
        ],

        romType: [
          { required: true, message: "请选择rom类型", trigger: "change" },
        ],
        romGameType: [
          { required: true, message: "请选择游戏类型", trigger: "change" },
        ],
        downloadLink: [
          { required: true, message: "请输入下载地址", trigger: "blur" },
        ],
        twodownloadLink: [
          { required: true, message: "请输入2号下载地址(宁波)", trigger: "blur" },
        ],
        mainFile: [
          { required: true, message: "请输入主文件", trigger: "blur" },
        ],
      },
      submitLoading: false,
      type: "add",

      // 5秒自动保存定时器(注释则取消自动保存)
      // autoSaveTimer: null,
    };
  },
  created() {
    this.type = this.$route.query.type;
    if (this.type === "edit") {
      const romId = this.$route.query.id;
      // 校验id是否存在
      if (!romId) {
        this.$message.error("缺少数据ID，无法编辑");
        this.$router.go(-1);
        return;
      }
      // 调用详情接口获取完整数据
      this.fetchRomDetail(romId);
    }
  },
  mounted() {
    this.romTypeList = this.getDictDatas(this.DICT_TYPE.ROM_TYPE);
    this.romGameTypeList = this.getDictDatas(this.DICT_TYPE.ROM_GAME_TYPE);
    this.romSupportedPlatformList = this.getDictDatas(this.DICT_TYPE.ROM_SUPPORTED_PLATFORM);
    this.statusList = this.getDictDatas(this.DICT_TYPE.STATUS);

    // 每5秒自动检查一次(方法注释则取消自动保存)
    // this.autoSaveTimer = setInterval(() => {
    //   this.autoSave();
    // }, 2000000);
  },
  methods: {
    // 上传rom图标
    uploadInfo(info) {
      this.romForm.romIcon = info;
    },

    // 5秒自动保存(方法注释则取消自动保存)
    // autoSave() {
    //   // 正在保存，不重复保存
    //   if (this.submitLoading) {
    //     return;
    //   }

    //   // 图标为空，不保存
    //   if (!this.romForm.romIcon) {
    //     return;
    //   }

    //   // 游戏类型为 -1，不保存
    //   if (
    //     this.romForm.romGameType === -1 ||
    //     this.romForm.romGameType === "-1"
    //   ) {
    //     return;
    //   }

    //   console.log("满足自动保存条件，开始自动保存");

    //   // 调用原来的保存方法
    //   this.submitForm("romForm");
    // },

    // 新建rom
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (!valid) {
          return false;
        }
        this.submitLoading = true;
        try {
          if (this.type === "add") {
            await setRom({
              ...this.romForm,
            });
            // this.$message.success("添加成功");
            // this.$router.go(-1);
            this.$message.success("添加成功");
            const backPage = Number(this.$route.query.page) || 1;
            this.$router.push({
              path: "/romList",
              query: { page: backPage }
            });
          } else {
            const {
              id,
              romIcon,
              romName,
              romNameEn,
              description,
              descriptionEn,
              romType,
              romGameType,
              downloadLink,
              twoDownloadLink,
              mainFile,
              romPlatformList,
              // 冗余字段
              fileSize,
              cloudFilePath,
            } = this.romForm;
            const params = {
              id,
              romIcon,
              romName,
              romNameEn,
              description,
              descriptionEn,
              romType,
              romGameType,
              downloadLink,
              twoDownloadLink,
              mainFile,
              romPlatformList,
              // 冗余字段
              fileSize,
              cloudFilePath,
            };
            await setRom(params);
            // this.$message.success("修改成功");
            // this.$router.go(-1);
            this.$message.success("修改成功");
            const backPage = Number(this.$route.query.page) || 1;
            this.$router.push({
              path: "/romList",
              query: { page: backPage }
            });
          }
        } catch (err) {
          // 后端报错、网络异常都会进这里
          console.error("保存ROM失败", err);
          this.$message.error("操作失败，请稍后重试");
        } finally {
          // 无论成功/失败，最后都关闭loading
          this.submitLoading = false;
        }

      });
    },
    resetForm() {
      // this.$refs[formName].resetFields();
      //his.$router.go(-1);
      const backPage = Number(this.$route.query.page) || 1;
      this.$router.push({
        path: "/romList",
        query: { page: backPage }
      });
    },
    // 根据id查询详情回填表单
    async fetchRomDetail(id) {
      try {
        const res = await getRomDetail(id);
        const data = res.result;
        // 赋值表单
        this.romForm = { ...data };
      } catch (err) {
        console.log("获取ROM详情失败{}", err);
        this.$message.error("获取ROM详情失败");
        this.$router.go(-1);
      }
    },

    // 新增一行平台明细
    addPlatformRow() {
      this.romForm.romPlatformList.push({
        id: "",
        romId: "",
        romSupportedPlatform: "",
        status: "",
        coreName: "",
        notes: ""
      });
    },
  },
  // 离开页面时清除5秒自动保存(方法注释则取消自动保存)
  // beforeDestroy() {
  //   if (this.autoSaveTimer) {
  //     clearInterval(this.autoSaveTimer);
  //     this.autoSaveTimer = null;
  //   }
  // },
};

</script>
<style lang="scss" scoped>
.addRom {
  ::v-deep .demo-romForm {
    .el-form-item__label {
      white-space: nowrap;
      min-width: 100px;
    }

    // 只给表单里 非表格 的el-input设宽度350px
    .el-form-item:not(.el-table__cell .el-form-item) .el-input {
      width: 350px;
    }

    // 表格内所有输入控件取消固定宽，自适应单元格
    .el-table__cell .el-input,
    .el-table__cell .el-select {
      width: 100% !important;
    }
  }
}
</style>
